// 1200px of content once the header's px-6 is removed: the width of the homepage, LP and health funnel content
export const HEADER_MAX_WIDTH = "max-w-[1248px]"
